import { SettingsStorageContext } from 'Components/Organisms/UserStorageProvider/UserStorageProvider';
import { useContext } from 'react';

export default function useSettingsStorage() {
    const context = useContext(SettingsStorageContext);

    if (!context) {
        throw new Error('useSettingsStorage must be used within a SettingsStorageProvider');
    }

    return context;
}
